export const documentsTypes = {
  'invoice': 'XML Da Nota',
  'invoice_pdf': 'Danfe',
  'invoice_label': 'Danfe simplificada',
  'label': 'Etiqueta',
  'return_invoice': 'Nota fiscal Devolução',
  'return_invoice_pdf': 'Danfe Devolução',
  'packing_list': 'romaneio',
  'payment_form': 'Forma de pagamento',
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/Orders/Shipments/Documents/documents-types.js